import { memo } from 'react';
import { Main } from './main/Loadable';

import InfoModal from './main/InfoModal';
const Spot = memo(() => {
    return (
        <>
            <Main />
            <InfoModal />
        </>
    )
})
    
export default Spot
